import SelectTool from '../SelectTool';

/**
 * 点选工具类
 */
export default class PointSelectTool extends SelectTool {
    /**
     * 构造方法
     * @param {object} options 可选项
     */
    constructor(options = {}) {
        super(options);
        this.hideInfo = options.hideInfo // 是否线时鼠标提示信息
        this.selectTolerance = options.selectTolerance || 15; // 配置捕获半径
        /**
         * 鼠标划过时选中的要素
         * @type {array}
         */
        this.hoveredFeatures = [];
    }

    /**
     * 获取捕捉查找数据的范围.
     * @param {object<geojson>}   point 点经纬度几何对象
     * @param {number}            tolerance   鼠标点的捕捉范围，单位为像素
     * @returns {object<geojson>} 边长为2*tol的点的外包矩形
     */
    getBox(point, tolerance) {
        const x = point.coordinates[0];
        const y = point.coordinates[1];
        const pixelPoint = this._map.project([y, x]);
        const left = pixelPoint.x - tolerance;
        const right = pixelPoint.x + tolerance;
        const top = pixelPoint.y - tolerance;
        const bottom = pixelPoint.y + tolerance;

        const geojson = {
            type: 'Polygon',
            coordinates: [],
        };

        const coordinates = [];
        const leftTop = this._map.unproject([left, top]);
        const rightTop = this._map.unproject([right, top]);
        const rightBottom = this._map.unproject([right, bottom]);
        const leftBottom = this._map.unproject([left, bottom]);

        coordinates.push([leftTop.lng, leftTop.lat]);
        coordinates.push([rightTop.lng, rightTop.lat]);
        coordinates.push([rightBottom.lng, rightBottom.lat]);
        coordinates.push([leftBottom.lng, leftBottom.lat]);
        coordinates.push([leftTop.lng, leftTop.lat]);

        geojson.coordinates = [coordinates];

        return geojson;
    }

    bindEvent(map) {
        map.on('click', this.onClick, this);
        map.on('mousemove', this.onMouseMove, this);
    }

    unbindEvent(map) {
        map.off('click', this.onClick, this);
        map.off('mousemove', this.onMouseMove, this);
    }

    onClick(mouseEvent) {
        super.onClick(mouseEvent);

        this.selectedFeatures = this.hoveredFeatures;
        this.hoveredFeatures = [];

        this.refreshFeedback();
        this.refreshMouseInfo('');

        this.finish();
    }

    onMouseMove(mouseEvent) {
        super.onMouseMove(mouseEvent);
        if (!this.hideInfo) {
            this.refreshMouseInfo('请点选地图要素');
        }
        
        const mousePoint = this.getMouseGeo();
        const box = this.getBox(mousePoint, this.selectTolerance);
        this.hoveredFeatures = this._featureSelector.selectByGeometry(box, this.options.filter);

        this.refreshFeedback();
    }

    resetFeedback() {
        super.resetFeedback();

        const items = [];
        if (this.hoveredFeatures && this.hoveredFeatures.length > 0) {
            this.hoveredFeatures.forEach(f => {
                items.push(...this.getHighlightItems(f, 1));
            });
        }
        if (items.length > 0) {
            this._feedback.addItems(items);
        }
    }
}
